const RotaIcon = () => {
  return (
    <div className="flex flex-col items-center gap-[3em] justify-center">
      <img className="block p-3 bg-white rounded-lg mt-[5em] max-w-[50vw]" src="https://www.scdf.gov.sg/images/default-source/about-scdf/sentosa-fire-station-tmb-ze-250-250.png?sfvrsn=df1432d2_1" alt="" />
      <h1 className="text-5xl uppercase">Rota 2</h1>
    </div>
  );
};

export default RotaIcon;
